import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  type = 'button', 
  variant = 'primary', 
  disabled = false,
  className = '',
  fullWidth = false
}) => {
  const baseStyles = 'px-4 py-3 rounded-button font-bold transition-colors min-h-[44px] touch-manipulation';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-hover disabled:bg-gray-400',
    secondary: 'bg-gray-400 text-white hover:bg-gray-500',
    danger: 'bg-red-600 text-white hover:bg-red-700',
    success: 'bg-green-500 text-white hover:bg-green-600',
    outline: 'border-2 border-gray-300 text-gray-900 hover:bg-gray-50'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
